import { Experience } from "../../types/types";

export const Experiences: Experience[] = [
    {
        title: "Frontend Developer (Consultant)",
        company: "Nobia",
        date: "sep 2022 - now",
    },
    {
        title: "Frontend Developer",
        company: "Garrison Consulting",
        date: "sep 2022 - now",
    },
    {
        title: "UX / Frontend Developer Intern",
        company: "Garrison Consulting",
        date: "apr 2022 - sep 2022",
    },
    {
        title: "Fullstack Developer Intern",
        company: "Yepstr",
        date: "jan 2022 - mar 2022",
    },
];
